<template>
  <OrganismMap :clubs="clubs" />
</template>

<script>
import OrganismMap from '../../components/organisms/layouts/OrganismMap'

export default {
  name: 'ClubsMap',
  components: { OrganismMap },
  meta: {
    theme: 'dark',
  },
  props: {
    context: {
      default: () => {},
      required: false,
      type: Object,
    },
  },
  head() {
    return {
      title: 'Карта клубов Encore Fitness в Москве',
      meta: [
        {
          hid: 'title',
          name: 'title',
          content: 'Карта клубов Encore Fitness в Москве',
        },
        {
          hid: 'description',
          name: 'description',
          content:
            'Откройте для себя премиальные клубы Encore Fitness с инновационной инфраструктурой, новейшими технологиями и современным интерьером. Выберите локацию на интерактивной карте, узнайте адреса и приходите в ближайший клуб.',
        },
      ],
    }
  },
  computed: {
    clubs() {
      const cityId = this.context.cityId
      return this.$store.getters['modules/content/clubs'].filter(({ city }) =>
        cityId !== 'all' ? city.id === cityId : true,
      )
    },
  },
}
</script>
